<div class="control-card-header">
  <div id="header" *ngIf="header">
    <ng-container>{{header}}</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>
  <div *ngIf="!header" id="headerConfirm">
    <ng-container i18n="@@confirmDialog_title">Conferma operazione</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>
</div>

<div class="control-card-content">

  <div id="messageDiv">
    {{message}}
  </div>

  <a *ngIf="confirmMessage" (click)="confirm()" class="button user-add-button" id="confirmButton">
    <ng-container>{{confirmMessage}}</ng-container>
    <span>
      <fa-icon icon="check"></fa-icon>
    </span>
  </a>

  <a *ngIf="cancelMessage" (click)="cancel()" class="button button-red" id="cancelButton">
    <ng-container>{{cancelMessage}}</ng-container>
    <span>
      <fa-icon icon="times"></fa-icon>
    </span>
  </a>

  <a *ngIf="!cancelMessage && !confirmMessage" (click)="closeDialog()" class="button user-add-button" id="okButton">
    <ng-container i18n="@@accessMethodGuide_ok">OK</ng-container>
    <span>
      <fa-icon icon="check"></fa-icon>
    </span>
  </a>

</div>
